import { useTranslation } from "react-i18next";
import { renderItem } from "./renderItem";
import { firstToUpper } from "../../../../../../../utils/helpers/string";

const fields = ["add", "clockIn", "clockOut", "deduct", "deductBetween", "days"];

const UnionRules = ({ data }) => {
    const { t } = useTranslation();

    return (
        <div className="tooltip-content-style">
            <h3 className="font-weight-bolder text-left mb-1">{t("union-rules")}</h3>
            {fields.map((item, i) => {
                return (
                    data?.[item] && (
                        <div key={i}>
                            <h4 className="mb-2 text-left" style={{ textDecoration: "underline", textUnderlineOffset: "2px" }}>{t(firstToUpper(item))}</h4>
                            {data?.[item]?.status && renderItem(data[item].status, "status", t)}
                            {data?.[item]?.start && renderItem(data[item].start, "start", t)}
                            {data?.[item]?.end && renderItem(data[item].end, "end", t)}
                            {data?.[item]?.runOnManualUpdate &&
                                renderItem(data[item].runOnManualUpdate, "run-on-manual-update", t)}
                            {data?.[item]?.amount && renderItem(data[item].amount, "amount", t)}
                            {data?.[item]?.clockOutAmount &&
                                renderItem(data[item].clockOutAmount, "clock-out-amount", t)}
                            {data?.[item]?.deduct && renderItem(data[item].deduct, firstToUpper("deduct"), t)}
                            {data?.[item]?.mark && renderItem(data[item].mark, "mark", t)}
                            {data?.[item]?.max && renderItem(data[item].max, "max", t)}
                            {data?.[item]?.min && renderItem(data[item].min, "min", t)}
                            {data?.[item]?.payCode && renderItem(data[item].payCode, "pay-code", t)}
                            {data?.[item]?.data && renderItem(data[item].data, "data", t)}
                            {data?.[item]?.days && renderItem(data[item].days, firstToUpper("days"), t)}
                        </div>
                    )
                );
            })}
        </div>
    );
};

export default UnionRules;
